export default "__VITE_ASSET__CYt3nX8W__"